/**
 * Venue-claim API schemas (API-1626).
 *
 * Shared by the advertiser self-serve claim flow and the admin claim queue.
 * The enum values mirror `VenueClaimStatus` in `db-core` without importing
 * Prisma into the validation package.
 */
import { z } from 'zod';

export const venueClaimStatusSchema = z.enum(['PENDING', 'APPROVED', 'REJECTED', 'REVOKED']);
export type VenueClaimStatusValue = z.infer<typeof venueClaimStatusSchema>;

export const venueClaimLocationPayloadSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
  })
  .strict();
export type VenueClaimLocationPayload = z.infer<typeof venueClaimLocationPayloadSchema>;

export const venueClaimAdvertiserPayloadSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    contactEmail: z.string(),
  })
  .strict();
export type VenueClaimAdvertiserPayload = z.infer<typeof venueClaimAdvertiserPayloadSchema>;

export const venueClaimPayloadSchema = z
  .object({
    id: z.string(),
    advertiserId: z.string(),
    locationId: z.string(),
    status: venueClaimStatusSchema,
    note: z.string().nullable(),
    decidedBy: z.string().nullable(),
    decidedAt: z.string().datetime().nullable(),
    decisionReason: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    location: venueClaimLocationPayloadSchema.optional(),
    advertiser: venueClaimAdvertiserPayloadSchema.optional(),
  })
  .strict();
export type VenueClaimPayload = z.infer<typeof venueClaimPayloadSchema>;

export const createVenueClaimSchema = z
  .object({
    locationId: z.string().trim().min(1).max(128),
    note: z
      .string()
      .trim()
      .min(1)
      .max(1000)
      .optional()
      .or(z.literal('').transform(() => undefined)),
  })
  .strict();
export type CreateVenueClaimBody = z.infer<typeof createVenueClaimSchema>;

export const adminVenueClaimDecisionSchema = z
  .object({
    reason: z.string().trim().min(1).max(1000),
  })
  .strict();
export type AdminVenueClaimDecisionBody = z.infer<typeof adminVenueClaimDecisionSchema>;

export const adminApproveVenueClaimSchema = z.object({}).strict();
export type AdminApproveVenueClaimBody = z.infer<typeof adminApproveVenueClaimSchema>;
